import React, {useEffect, useState} from "react";
import _ from "lodash";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";
import {PINTEREST_BOARD_INPUT_FIELDS} from "../../constants/pinterest-board.constant";
import {addSinglePinterestBoard, updateSinglePinterestBoard} from "../../services/pinterest-board-data.service";
import {handleFieldValueChanges, prepareInputFields} from "../../../common/utils/field-change-util";
import RenderFields from "../../../common/ui/render-fields";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";

const AddEditPinterestBoard = ({
                                   selectedPinterestBoard = {},
                                   refreshPinterestBoardList,
                                   isAddPinterestBoard = false,
                                   isEditPinterestBoard = false
                               }) => {
    const [showModal, setShowModal] = useState(false);
    const [pinterestBoard, setPinterestBoard] = useState(selectedPinterestBoard);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [pinterestBoardFieldInputs, setPinterestBoardFieldInputs] = useState(PINTEREST_BOARD_INPUT_FIELDS);

    useEffect(() => {

        if (showModal) {
            if (isEditPinterestBoard) {
                setPinterestBoard(selectedPinterestBoard);
            } else {
                setPinterestBoard({});
            }
        }

    }, [showModal]);

    const handleConfirmAction = async () => {
        setSaveInProgress(true);

        const existingPinterestBoard = {...pinterestBoard};

        if (isEditPinterestBoard) {
            await updateSinglePinterestBoard(existingPinterestBoard);
        } else {
            await addSinglePinterestBoard(existingPinterestBoard);
        }

        setSaveInProgress(false);
        refreshPinterestBoardList();
        setShowModal(false);
    }

    const handlePinterestBoardChanges = (event) => {
        let existingPinterestBoard = {...pinterestBoard};
        existingPinterestBoard = handleFieldValueChanges(event, existingPinterestBoard);

        const {name} = event.target;
        if (name === 'pinterestBoardType') {
            const newFields = prepareInputFields(PINTEREST_BOARD_INPUT_FIELDS, event.target, existingPinterestBoard);
            setPinterestBoardFieldInputs(newFields);
        }

        setPinterestBoard(existingPinterestBoard);
    }

    const handleCloseAction = () => {
        setShowModal(false);
    }

    return (
        <>
            {isAddPinterestBoard &&
                <button
                    className="button-green px-2 py-1"
                    onClick={() => setShowModal(true)}>
                    Add Pinterest Board
                </button>
            }

            {isEditPinterestBoard &&
                <button
                    className="button-green-outline px-3 py-1"
                    onClick={() => setShowModal(true)}>
                    Edit
                </button>
            }

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-1/2 my-6 mx-auto max-w-3xl">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-gray-100 outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        {isAddPinterestBoard &&
                                            <>Add Pinterest Board</>
                                        }

                                        {isEditPinterestBoard &&
                                            <>Edit Pinterest Board</>
                                        }
                                    </h3>

                                    <div className="">
                                        <button
                                            className="button-gray-outline px-1 py-1"
                                            onClick={handleCloseAction}>
                                            <div className="">
                                                <XMarkIcon className="h-6 w-6"/>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                {/*body*/}
                                <div className="relative p-5 flex-auto">
                                    <div className="leading-relaxed">
                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={pinterestBoard}
                                                handleDetailChanges={handlePinterestBoardChanges}
                                                fieldList={_.groupBy(pinterestBoardFieldInputs, 'group')['pinterestBoard']}
                                                enableEdit={true}/>
                                        </div>

                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={pinterestBoard}
                                                handleDetailChanges={handlePinterestBoardChanges}
                                                fieldList={_.groupBy(pinterestBoardFieldInputs, 'group')['detail']}
                                                enableEdit={true}
                                                fieldClassName={'w-full'}/>
                                        </div>

                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={pinterestBoard}
                                                handleDetailChanges={handlePinterestBoardChanges}
                                                fieldList={_.groupBy(pinterestBoardFieldInputs, 'group')['filter']}
                                                enableEdit={true}
                                                fieldClassName={'w-1/2'}/>
                                        </div>
                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-blueGray-200 rounded-b">
                                    <div className="ml-4 -mt-1">
                                        <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                                    </div>
                                    <button
                                        className="ml-2 text-gray-500 font-bold border border-gray-500 h-8 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-8 px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Pinterest Board
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default AddEditPinterestBoard
